module.exports = __webpack_public_path__ + "static/media/pack-ur-bags-logo.d48185b4.png";